module.exports = __webpack_public_path__ + "img/CZ27943445.060457d2.png";